import React from "react";
import { motion } from "framer-motion";

import Img1 from "../image/offer/1.png";
import Img2 from "../image/offer/2.png";
import Img3 from "../image/offer/3.png";
import Img4 from "../image/offer/4.png";
import Img5 from "../image/offer/5.png";

export default function Offer() {
  const items = [
    {
      title: "Creative Challenges",
      text: "Artistic challenges that help artists grow their skills, unlock achievements, gain audience attention, and win rewards.",
      img: Img1,
    },
    {
      title: "Digital Gallery",
      text: "A curated platform where artists can publish artworks and gain visibility from art lovers, collectors, and other creators.",
      img: Img2,
    },
    {
      title: "Learning Resources",
      text: "Tutorials, guides, webinars, and knowledge material designed to help artists strengthen their technique and artistic voice.",
      img: Img3,
    },
    {
      title: "Personalized Growth",
      text: "Members and patrons can take quizzes, receive feedback on submissions, and track progress toward their creative goals.",
      img: Img4,
    },
    {
      title: "Patron Membership",
      text: "A unique tier system that gives supportive patrons early access, exclusive content, perks, and multiple opportunities.",
      img: Img5,
    },
  ];

  const Card = ({ title, text, img, index }) => (
    <motion.div
      className="relative rounded-xl overflow-hidden shadow-lg h-64 group"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      whileHover={{ scale: 1.05, rotate: 1 }}
    >
      <motion.img
        src={img}
        alt={title}
        className="w-full h-full object-cover"
        whileHover={{ scale: 1.12 }}
        transition={{ duration: 0.4 }}
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-black/0 p-5 flex flex-col justify-end text-white">
        <h3 className="text-lg font-semibold font-cinzel">{title}</h3>
        <p className="text-sm mt-1 font-outfit">{text}</p>
      </div>
    </motion.div>
  );

  return (
    <section className="py-16 px-6">
      <h2 className="text-center text-4xl font-serif mb-12 font-cinzel">
        What We Offer
      </h2>

      {/* First Row – 3 items */}
      <div className="grid grid-cols-1 md:grid-cols-3 max-w-8xl gap-10">
        {items.slice(0, 3).map((item, index) => (
          <Card key={index} {...item} index={index} />
        ))}
      </div>

      {/* Second Row – 2 centered items */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12 max-w-4xl mx-auto">
        {items.slice(3).map((item, index) => (
          <Card key={index} {...item} index={index + 3} />
        ))}
      </div>
    </section>
  );
}
